import DOMPurify from 'dompurify'
import { marked } from 'marked'

const purifyConfig = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'ul',
    'ol',
    'li',
    'strong',
    'em',
    'code',
    'pre',
    'blockquote',
    'img',
    'a',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td',
  ],
  ALLOWED_ATTR: ['src', 'href', 'alt', 'title'],
}

export function markdown(text) {
  purifyConfig.ALLOWED_TAGS.push('h1', 'h2', 'h3', 'h4', 'h5', 'h6')
  return DOMPurify.sanitize(marked.parse(text), purifyConfig)
}


export function markdown2(text) {
  return DOMPurify.sanitize(marked.parse(text), purifyConfig)
}


export function shouldUseBlackText(hexColor) {
    // Odstranění # ze začátku, pokud existuje
    hexColor = hexColor.replace(/^#/, '');

    // Převod hex na RGB
    const r = parseInt(hexColor.substr(0, 2), 16);
    const g = parseInt(hexColor.substr(2, 2), 16);
    const b = parseInt(hexColor.substr(4, 2), 16);

    // Převod RGB na relativní svítivost
    const rSRGB = r / 255;
    const gSRGB = g / 255;
    const bSRGB = b / 255;

    // Gamma korekce
    const rLinear = rSRGB <= 0.03928 ? rSRGB / 12.92 : Math.pow((rSRGB + 0.055) / 1.055, 2.4);
    const gLinear = gSRGB <= 0.03928 ? gSRGB / 12.92 : Math.pow((gSRGB + 0.055) / 1.055, 2.4);
    const bLinear = bSRGB <= 0.03928 ? bSRGB / 12.92 : Math.pow((bSRGB + 0.055) / 1.055, 2.4);

    // Výpočet relativní svítivosti
    const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

    // Hraniční hodnota je přibližně 0.5
    return luminance > 0.5;
}

export function getTextColor(backgroundColor) {
    return shouldUseBlackText(backgroundColor) ? 'black' : 'white';
}
